import { Pipe, PipeTransform } from '@angular/core';
import { IMarkerPoint } from "libraries/map/IPoint";
import { IGeoposition } from "libraries/hotel/models/hotel";

/**
 * Transforms a IGeoposition to a IMarkerPoint. Useful for map display.
 */
@Pipe({
    name: 'toMarkerPoint'
})
export class ToMarkerPointPipe implements PipeTransform {

    public transform(geoposition: IGeoposition): IMarkerPoint {
        return {
            latitude: geoposition && this.toNumber(geoposition.latitude),
            longitude: geoposition && this.toNumber(geoposition.longitude)
        };
    }

    // Need to transform string to number type for show marker
    private toNumber(numberString: string | number): number {
        return Number(numberString);
    }

}
